import MultiValueNoChipText from './MultiValueNoChipText';

export default MultiValueNoChipText;
